export const customTooltips = function (tooltip) {
  const isMobile = window.innerWidth < 500;

  // Tooltip Element
  let tooltipEl = document.getElementById('chartjs-tooltip');

  // Create element on first render
  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.id = 'chartjs-tooltip';
    tooltipEl.innerHTML = '<div class="tooltip-content"></div><div class="tooltip-arrow" style="position: absolute; width: 0; height: 0; border-left: 10px solid transparent; border-right: 10px solid transparent; border-top: 10px solid rgba(0, 0, 0, 0.8); bottom: -10px; left: 50%; transform: translateX(-50%);"></div>';
    document.body.appendChild(tooltipEl);
  }

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  // Set Text
  if (tooltip.body) {
    const titleLines = tooltip.title || [];
    const bodyLines = tooltip.body.map(bodyItem => bodyItem.lines);
    let innerHtml = '';

    titleLines.forEach(title => {
      const fontSize = isMobile ? '7px' : '8.1px';
      innerHtml += `<div style="font-size: ${fontSize}; margin-bottom: 0px; color: white;">${title}</div>`;
    });

    bodyLines.forEach((body, i) => {
      const span = '<span style="font-size: 14px; font-weight: bold; color: white;">' + body + '</span>';
      innerHtml += span;
    });

    const tableRoot = tooltipEl.querySelector('.tooltip-content');
    tableRoot.innerHTML = innerHtml;
  }

  // `this` will be the overall tooltip
  const position = this._chart.canvas.getBoundingClientRect();

  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1;
  tooltipEl.style.position = 'absolute';
  tooltipEl.style.left = position.left + window.pageXOffset + tooltip.caretX - 35 + 'px';
  tooltipEl.style.top = position.top + window.pageYOffset + tooltip.caretY - 90 + 'px';
  tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px';
  tooltipEl.style.borderRadius = '50%';
  tooltipEl.style.pointerEvents = 'none';
  tooltipEl.style.width = '70px';
  tooltipEl.style.height = '70px';
  tooltipEl.style.display = 'flex';
  tooltipEl.style.justifyContent = 'center';
  tooltipEl.style.alignItems = 'center';
  tooltipEl.style.textAlign = 'center';
  tooltipEl.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
};


// WEBPACK FOOTER //
// ./src/new/Utils/customTooltips.js